import { useEffect, useState } from "react";
import DataTable from "../../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../../helper/ApiRequest";
import { ApiEndpoints } from "../../../helper/ApiEndpoints"; 
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";

const deleteEndpoint = ApiEndpoints.project.delete;
const listEndpoint = ApiEndpoints.project.list;
const editPath = "edit-project";
const tableHeader = ["Title", "Slug",];
const tbody = ["title", "slug",];

export default function Project() {

  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", listEndpoint);
      const result = response.projects;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => { 
    dataFetch();
  }, []);

  const handleDelete = async (project_id) => {
      const payload = { project_id };
      try {
        const response = await ApiRequest("POST", deleteEndpoint, payload);
        toast.success(response.message)
        dataFetch();
      } catch (error) {
        console.error(error);
      }
    };

    const pagename = {
      name: 'Project Management',
      user: 'Admin',
      innerpage: 'Project Management / Project'
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>

      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-project">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={editPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
